import { render, staticRenderFns } from "./ChartPrazoMedioReclamacoesImprocedentesEncerradasPorCompetencia.vue?vue&type=template&id=21d32de0&"
import script from "./ChartPrazoMedioReclamacoesImprocedentesEncerradasPorCompetencia.vue?vue&type=script&lang=js&"
export * from "./ChartPrazoMedioReclamacoesImprocedentesEncerradasPorCompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports